export default function About(){
    return (
        <div className="">
About Kinyamateka  

        </div>
    );
}